import { createReducer } from "typesafe-actions";

import {
  Company,
  Deal,
  EntityTypeSupportingPostCreationModal,
  Person,
} from "@mapmycustomers/shared/types/entity";

import {
  Actions,
  addCompanyChildCompanies,
  addCompanyDeals,
  addCompanyParentCompany,
  addCompanyPeople,
  addDealParentCompany,
  addDealParentPerson,
  addPersonCompanies,
  addPersonDeals,
  hideGlobalPostCreationModal,
  showGlobalPostCreationModal,
} from "./actions";

export interface PostCreationModalState {
  childCompanies?: Company[];
  companyDeals: Deal[];
  companyParentCompany?: Company;
  companyPeople?: Person[];
  dealParentCompany?: Company;
  dealParentPerson?: Person;
  entityType?: EntityTypeSupportingPostCreationModal;
  loading: boolean;
  personCompanies: Company[];
  personDeals: Deal[];
  personParentCompany?: Company;
  prefilledValues?: Company | Deal | Person;
  visible: boolean;
}

const initialState: PostCreationModalState = {
  companyDeals: [],
  loading: false,
  personCompanies: [],
  personDeals: [],
  visible: false,
};

const postCreationModal = createReducer<PostCreationModalState, Actions>(initialState)
  .handleAction(showGlobalPostCreationModal, (state, action) => ({
    ...state,
    entityType: action.payload?.entityType,
    prefilledValues: action.payload?.entity,
    visible: true,
  }))
  .handleAction(hideGlobalPostCreationModal, (state) => ({
    ...state,
    entityType: undefined,
    prefilledValues: undefined,
    visible: false,
  }))
  .handleAction(addCompanyChildCompanies.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(addCompanyChildCompanies.success, (state, action) => ({
    ...state,
    childCompanies: action.payload,
    loading: false,
  }))
  .handleAction(addCompanyChildCompanies.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(addCompanyDeals.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(addCompanyDeals.success, (state, action) => ({
    ...state,
    companyDeals: action.payload,
    loading: false,
  }))
  .handleAction(addCompanyDeals.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(addPersonDeals.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(addPersonDeals.success, (state, action) => ({
    ...state,
    loading: false,
    personDeals: action.payload,
  }))
  .handleAction(addPersonDeals.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(addCompanyParentCompany.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(addCompanyParentCompany.success, (state, action) => ({
    ...state,
    companyParentCompany: action.payload,
    loading: false,
  }))
  .handleAction(addCompanyParentCompany.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(addPersonCompanies.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(addPersonCompanies.success, (state, { payload }) => ({
    ...state,
    loading: false,
    personCompanies: payload,
  }))
  .handleAction(addPersonCompanies.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(addDealParentCompany.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(addDealParentCompany.success, (state, action) => ({
    ...state,
    dealParentCompany: action.payload,
    loading: false,
  }))
  .handleAction(addDealParentCompany.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(addCompanyPeople.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(addCompanyPeople.success, (state, action) => ({
    ...state,
    companyPeople: action.payload,
    loading: false,
  }))
  .handleAction(addCompanyPeople.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(addDealParentPerson.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(addDealParentPerson.success, (state, action) => ({
    ...state,
    dealParentPerson: action.payload,
    loading: false,
  }))
  .handleAction(addDealParentPerson.failure, (state) => ({
    ...state,
    loading: false,
  }));

export * from "./selectors";
export type PostCreationModalActions = Actions;
export default postCreationModal;
